module.exports = __webpack_public_path__ + "static/img/SFG120-BT.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/SFG120-BT.png
// module id = RZk5
// module chunks = 0